export default __webpack_public_path__ + "media/zurb/img/about/bryan/instagram-icon-01-0aaefabb1bd80e14ece7a67a8d4a66cb.png";